var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg040306(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 69,
    viewBox: "0 0 76 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_247_371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5968 59.8408C46.8408 60.48 44.9413 60.4175 43.2415 59.6743L18.2332 50.4161C13.5216 48.2279 10.0147 44.2272 8.50999 39.3761C7.77561 37.017 7.54442 34.5721 7.81791 32.1136C8.10403 29.5533 8.91587 27.1056 10.2549 24.843C12.3561 21.2938 15.5599 18.6564 19.5328 17.2104C24.0434 15.5687 29.5932 18.0109 34.0284 19.8498C36.2439 15.5902 39.551 9.92437 44.0507 8.2866C48.0236 6.84058 52.173 6.80157 56.0641 8.1698C58.5443 9.04233 60.7505 10.3915 62.6045 12.1729C64.3943 13.8804 65.7779 15.9059 66.7317 18.1851C68.6935 22.8577 68.5826 28.1873 66.4075 32.797L66.358 32.9001L66.2442 33.0996L52.5238 56.3566C51.7418 57.9301 50.3269 59.199 48.5819 59.8341L48.5968 59.8408Z",
    fill: "#FF4C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4497 62.1841C49.5386 62.1517 49.6248 62.1146 49.7081 62.0732C51.8855 61.2061 53.6752 59.5873 54.7134 57.5527L68.3919 34.3666L68.4101 34.3352L68.5239 34.1358C68.5532 34.0844 68.5807 34.032 68.6063 33.9787L68.6558 33.8756L68.6626 33.8611C71.1393 28.6122 71.2666 22.5449 69.0309 17.2198C67.9469 14.6307 66.3695 12.3192 64.3289 10.3716C62.212 8.33854 59.6978 6.80474 56.8916 5.81753L56.8913 5.8174C52.4421 4.25295 47.6989 4.30513 43.1978 5.94339C40.2998 6.99816 37.9935 9.25472 36.2107 11.5592C34.9356 13.2073 33.8317 15.0084 32.8977 16.6845C31.2008 15.9967 29.32 15.289 27.4216 14.8077C24.7033 14.1186 21.6137 13.7994 18.6799 14.8672C14.1788 16.5055 10.5117 19.5144 8.10915 23.5727L8.10897 23.573C6.58976 26.14 5.66497 28.9263 5.33972 31.8367L5.33959 31.8379C5.02835 34.6357 5.29165 37.4265 6.12869 40.1161C7.84558 45.65 11.8428 50.1976 17.1828 52.6777C17.2433 52.7058 17.3049 52.7315 17.3674 52.7546L42.3133 61.9897C44.582 62.9604 47.1161 63.0334 49.4497 62.1841Z",
    stroke: "white",
    strokeWidth: 4.9872,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_247_371",
    x: 0.225881,
    y: 0.314613,
    width: 75.38,
    height: 68.0691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6234
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2468
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_247_371",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg040306);
export default __webpack_public_path__ + "static/media/img_04_03_06.8c1a85bfb44cb1c522f20ec38c097192.svg";
export { ForwardRef as ReactComponent };